exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".text-icon__button{height:100%;border:2px solid transparent;padding-top:24px;padding-bottom:24px}.text-icon__button.is-clickable:hover{cursor:pointer;border:2px solid #2d74da}.text-icon__button.is-selected{border-color:#2d74da}.text-icon__button.is-focus{outline:none}.text-icon__header{font-size:1rem;font-weight:700}.text-icon__header,.text-icon__sub_header{line-height:1.25rem;padding-bottom:8px}.text-icon__body{font-size:.875rem;line-height:1.125rem}.text-icon__icon{fill:#00baa1}", ""]);

// exports
